export const EDDY_CURRENT = 1;
export const FLUX = 2;
export const ABS_DIFF = 3;
export const RFEC = 4;
export const LABEL_EDDY_CURRENT = 'Eddy Current';
export const LABEL_FLUX = 'Flux';
export const LABEL_ABS_DIFF = 'Abs/Diff';
export const LABEL_RFEC = 'RFEC';
